import src from "IMAGE";
export default { src, width: 1382, height: 980, blurWidth: 0, blurHeight: 0};
